module.exports = __webpack_public_path__ + "img/2.d1cc76c2.gif";